import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { Modal } from 'src/common/primitives/Modal';

import { adminActions } from '../admin.slice';
import { MTMSettingsFormController } from '../forms/MTMSettingsForm';

export function MTMSettingsFormModal() {
  const dispatch = useAppDispatch();
  const editingMtmSettingsId = useAppSelector(
    (state) => state.admin.editingMtmSettingsId
  );
  const showMtmSettingsModal = useAppSelector(
    (state) => state.admin.showMtmSettingsModal
  );

  const handleClose = useCallback(() => {
    dispatch(adminActions.setShowMtmSettingsModal(false));
  }, [dispatch]);

  return (
    <Modal
      open={showMtmSettingsModal}
      onClose={handleClose}
      onInteractOutside={handleClose}
      setOpen={handleClose}
      title={editingMtmSettingsId ? 'Edit MTM Settings' : 'Add MTM Settings'}
    >
      <div className="flex w-full flex-col gap-2 md:min-w-[350px]">
        <h3 className="text-[24px] font-medium leading-6 text-gray-900">
          {editingMtmSettingsId ? 'Edit MTM Settings' : 'Add MTM Settings'}
        </h3>
        <MTMSettingsFormController settingsId={editingMtmSettingsId} />
      </div>
    </Modal>
  );
}
